import React, { FC, useCallback, useEffect, useState } from 'react'
import { Button, Checkbox } from '@wmgtech/legato'

import { Editor, PageHeader } from 'components'

import { toolbarModules } from 'shared/quill/editorOptions'

import { MessagesProps } from './Messages.props'
import './Messages.scss'

const Messages: FC<MessagesProps> = ({ messageData: { id, active, message }, updateInfoMessage, messageLoading }) => {
  const [editorValue, updateValue] = useState<string>('')
  const [activeValue, updateActive] = useState<boolean>(false)

  const updateInfoMessageHandler = useCallback(
    () => updateInfoMessage({ id, active: activeValue, message: editorValue }),
    [activeValue, editorValue, id, updateInfoMessage]
  )
  const toggleActive = useCallback(() => updateActive(!activeValue), [activeValue])

  useEffect(() => {
    updateValue(message)
    updateActive(active)
  }, [active, message])

  return (
    <div className="messages-box">
      <div className="messages">
        <PageHeader title="Message" />
        <Editor
          initialValue={message}
          onChangeValue={updateValue}
          modules={toolbarModules.loginMessage}
          placeholder="This text area informs users of situations that might affect their usage of Storybox, i.e., Tiktok embeds are currently not working. "
        />
        <div className="messages__inputs">
          <Checkbox
            className="messages__checkbox"
            onChange={toggleActive}
            checked={activeValue}
            label='"Active" status to show or hide message'
          />
          <Button
            htmlType="button"
            disabled={messageLoading}
            onClick={updateInfoMessageHandler}
            colorType="secondary-white"
            containerStyle="outline"
            size="md"
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Messages
